import { z } from "zod";

export type Histogram = { choice: string; count: number }[];
export interface AggregatedAnswer {
  questionId: string;
  histogram?: Histogram; // "text" type questions don't have a histogram
  textSummary?: string; // For "text" type questions
}

export interface SurveyResults {
  surveyid: string;
  aggregatedAnswers: AggregatedAnswer[];
}

//TODO refine to make sure all the questions and only the questions are present, also about the answer validity
const AggregatedAnswerSchema = z.object({
  questionId: z.string(),
  histogram: z
    .array(
      z.object({
        choice: z.string(),
        count: z.number(),
      })
    )
    .optional(),
  textSummary: z.string().optional(),
});

export const SurveyResultsSchema = z.object({
  surveyid: z.string(),
  aggregatedAnswers: z.array(AggregatedAnswerSchema),
});

export function validateHistogram(histogram: Histogram) {
  const seenChoices = new Set();
  for (const item of histogram) {
    if (typeof item.choice !== "string" || item.choice.trim() === "") {
      throw new Error(`Choice must be a non-blank string.`);
    }
    if (seenChoices.has(item.choice)) {
      throw new Error(`Duplicate choice found: '${item.choice}'.`);
    }
    seenChoices.add(item.choice);
  }
}
